module.exports = __webpack_public_path__ + "static/media/forget.8b8a8dc6.svg";